const backendBase = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/?$/, '/');

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

const tenantId = () => localStorage.getItem('tenantId') || localStorage.getItem('tenant_id');

/**
 * List per-LLM-call token usage for an agent.
 * @param {string} agentId tenantAgentInstanceId (preferred) or agentUniqueId
 * @param {{ limit?: number, includeRunTotals?: boolean }} [opts]
 */
export const fetchAgentTokenUsage = async (agentId, opts = {}) => {
  const tid = tenantId();
  if (!agentId || !tid) {
    throw new Error('Missing agent or tenant context');
  }
  const limit = opts.limit ?? 200;
  const includeRunTotals = opts.includeRunTotals ? 'true' : 'false';
  const url =
    `${backendBase}synctrack/ai-execution/token-usage` +
    `?tenant_id=${encodeURIComponent(tid)}` +
    `&agent_id=${encodeURIComponent(agentId)}` +
    `&limit=${encodeURIComponent(limit)}` +
    `&include_run_totals=${includeRunTotals}`;
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.message || `Failed to load token usage (${res.status})`);
  }
  return res.json();
};
